var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right__subsection"},[_c('p',{staticClass:"right__subsection__title"},[_vm._v("相关产品")]),_c('div',{staticClass:"right__subsection__flex"},[_c('p',{staticClass:"right__subsection__english"},[_vm._v("Product Center")]),_c('router-link',{staticClass:"right__subsection__more",attrs:{"to":"/center"}},[_vm._v("更多产品详情 >>")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }